import { useState, useEffect } from "react";
import { Button, Input, Modal } from "rsuite";
import ProfileBold from "shared/Icons/ProfileBold";
import { ParticipantInfo } from "core/models/Bracket";

interface EditParticipantProps {
  open: boolean;
  participant: ParticipantInfo;
  onClose: () => void;
  onMemberChange: (index: number, field: string, value: string) => void;
  onCustomFieldChange: (
    memberIndex: number,
    fieldIndex: number,
    fieldKey: string,
    value: string
  ) => void;
  onSave: () => void;
}

export default function EditParticipant({
  open,
  participant,
  onClose,
  onMemberChange,
  onCustomFieldChange,
  onSave,
}: EditParticipantProps) {
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (open) setIsEditing(false);
  }, [open]);

  if (!participant) return null;

  const toggleEditMode = () => {
    if (isEditing) {
      onSave();
    }
    setIsEditing(!isEditing);
  };

  return (
    <Modal open={open} onClose={onClose} size="md">
      <Modal.Header>
        <Modal.Title>Edit Participants</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="participants-container">
          <div className="team-header">
            <div className="team-name-container">
              <div className="team-image">
                {participant.media ? (
                  <img
                    src={participant.media.profileImage}
                    width={32}
                    height={32}
                    alt="Team Profile"
                  />
                ) : (
                  <ProfileBold />
                )}
              </div>
              <div className="team-name">
                <div className="name-container">
                  <p className="name">{participant?.name}</p>
                  <p className="member-count">{`(${participant?.members.length})`}</p>
                </div>
              </div>
            </div>
          </div>
          <hr className="divider" />
          <div className="participant-member-wrapper">
            {participant?.members?.map((member, mIndex) => {
              return (
                <div className="participant-member" key={mIndex}>
                  <div className="member-header">
                    <div className="member-profile">
                      <img
                        src={member?.profileImg?.profileImg}
                        alt="profile img"
                        className="profile-img"
                      />
                      <div className="member-name">{member?.username}</div>
                    </div>
                  </div>
                  <div className="member-grid-wrapper">
                    <div className="input-select-wrapper">
                      <label>In Game Name</label>
                      <Input
                        style={{ marginTop: "5px" }}
                        value={member?.inGameName}
                        placeholder={`Enter Ingame Name`}
                        onChange={(val) =>
                          isEditing && onMemberChange(mIndex, "inGameName", val)
                        }
                        readOnly={!isEditing}
                      />
                    </div>
                    {member?.inGameId!==undefined && (
                      <div className="input-select-wrapper">
                        <label>In Game Id</label>
                        <Input
                          style={{ marginTop: "5px" }}
                          value={member?.inGameId}
                          placeholder={`Enter InGame Id`}
                          onChange={(val) =>
                            isEditing && onMemberChange(mIndex, "inGameId", val)
                          }
                          readOnly={!isEditing}
                        />
                      </div>
                    )}
                  </div>
                  <div className="member-grid-wrapper">
                    {member?.customFields.map((customField, fIndex: number) => {
                      const fieldKey = Object.keys(customField).find(
                        (key) => key !== "visibility"
                      ) as string;

                      const fieldValue =
                        fieldKey && (customField as any)[fieldKey];

                      return (
                        <div key={fIndex} className="input-select-wrapper">
                          <label>{fieldKey}</label>
                          <Input
                            style={{ marginTop: "5px" }}
                            value={fieldValue}
                            placeholder={`Enter ${fieldKey}`}
                            onChange={(val) =>
                              isEditing &&
                              onCustomFieldChange(mIndex, fIndex, fieldKey, val)
                            }
                            readOnly={!isEditing}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance={isEditing ? "default" : "ghost"}
          onClick={toggleEditMode}
        >
          {isEditing ? "Update" : "Edit"}
        </Button>
        <Button appearance="ghost" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
